<div class="card pass-business-page">

    <div class="card-header">
        <h1>
            Pass Business

            <i
                class="fa fa-circle-plus clickeable text-info"
                title="Agregar contraseña"
                (click)="createPassBusiness()">
            </i>
        </h1>
    </div>

    <div class="card-body">

        <!-- Filtro de empresas -->
        <div class="form-group mb-4">
            <label for="searchCompany" class="form-label">
                Buscar empresa
            </label>

            <input
                type="text"
                id="searchCompany"
                name="searchCompany"
                class="form-control"
                [(ngModel)]="filterWord"
                (input)="filterCompany()"
                autocomplete="off"
                placeholder="Ingresa nombre, NIT o código de empresa">
        </div>

        <!-- Cards -->
        <div class="grid-companies" *ngIf="!gettingData">

            <ng-container
                *ngFor="let company of companiesPass; trackBy: trackByCompany">

                <div class="card container-pass-business">

                    <!-- Header de empresa -->
                    <div class="card-header company-header">

                        <h5 [title]="company.company.name">
                            {{ company.company.name }}
                        </h5>

                        <span class="badge badge-info">
                            {{ company.passes.length }}
                            {{ company.passes.length === 1
                                ? 'registro'
                                : 'registros' }}
                        </span>

                    </div>

                    <div class="card-body">

                        <!-- Información principal -->
                        <div class="company-information">

                            <img
                                class="company-logo"
                                [src]="getCompanyLogo(company)"
                                (error)="logoError($event)"
                                alt="Logo empresa">

                            <div class="company-details">

                                <strong>
                                    {{ company.company.nit || 'Sin NIT' }}
                                </strong>

                                <span class="text-muted">
                                    {{ company.company.alphanumericId }}
                                </span>

                            </div>

                        </div>

                        <!-- Botón para expandir -->
                        <button
                            type="button"
                            class="btn btn-outline-info btn-sm btn-block mt-3"
                            (click)="toggleCompany(company)">

                            <i
                                class="fa"
                                [ngClass]="company.expanded
                                    ? 'fa-chevron-up'
                                    : 'fa-chevron-down'">
                            </i>

                            {{ company.expanded
                                ? 'Ocultar contraseñas'
                                : 'Ver contraseñas' }}

                        </button>

                        <!-- Listado de contraseñas -->
                        <div
                            class="passes-container"
                            *ngIf="company.expanded">

                            <ng-container
                                *ngFor="let pass of company.passes; trackBy: trackByPass">

                                <div class="pass-item">

                                    <div class="pass-header">

                                        <span class="pass-type">
                                            <i class="fa fa-key text-info"></i>
                                            {{ pass.typeName }}
                                        </span>

                                        <!-- <span class="pass-type-number">
                                            Tipo {{ pass.type }}
                                        </span> -->

                                    </div>

                                    <!-- Visualización -->
                                    <div class="input-group pass-input-group">

                                        <button
                                            class="btn btn-primary"
                                            type="button"
                                            title="Editar contraseña"
                                            (click)="editPassBusiness(pass, company)">

                                            <i class="fa fa-edit"></i>

                                        </button>

                                        <input
                                            class="form-control"
                                            [type]="pass.visible ? 'text' : 'password'"
                                            [value]="pass.pass"
                                            readonly
                                            autocomplete="off">

                                        <button
                                            class="btn btn-outline-secondary"
                                            type="button"
                                            [title]="pass.visible
                                                ? 'Ocultar contraseña'
                                                : 'Mostrar contraseña'"
                                            (click)="toggleVisibility(pass)">

                                            <i
                                                class="fa"
                                                [ngClass]="pass.visible
                                                    ? 'fa-eye-slash'
                                                    : 'fa-eye'">
                                            </i>

                                        </button>

                                        <button
                                            class="btn btn-primary"
                                            type="button"
                                            title="Copiar contraseña"
                                            (click)="copy(pass.pass)">

                                            <i class="fa fa-paste"></i>

                                        </button>

                                    </div>

                                    <!-- Eliminar -->
                                    <div class="pass-actions">

                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            (click)="confirmDelete(pass)">

                                            <i class="fa fa-trash"></i>

                                        </button>

                                    </div>

                                    <!-- Confirmación de eliminación -->
                                    <div
                                        class="delete-pass-confirmation"
                                        *ngIf="pass.deleting">

                                        <ng-container *ngIf="!deleting[pass.id]">

                                            <span class="confirmation-title">
                                                ¿Estás seguro de eliminar
                                                esta contraseña?
                                            </span>

                                            <!-- <span class="text-muted">
                                                Tipo: {{ pass.typeName }}
                                            </span> -->

                                            <div class="confirmation-buttons">

                                                <button
                                                    type="button"
                                                    class="btn btn-danger btn-sm"
                                                    (click)="deletePassBusiness(pass)">

                                                    <i class="fa fa-trash"></i>
                                                    Sí, eliminar

                                                </button>

                                                <button
                                                    type="button"
                                                    class="btn btn-info btn-sm"
                                                    (click)="cancelDelete(pass)">

                                                    <i class="fa fa-ban"></i>
                                                    Cancelar

                                                </button>

                                            </div>

                                        </ng-container>

                                        <app-loading-animation
                                            *ngIf="deleting[pass.id]"
                                            [height]="'3rem'">
                                        </app-loading-animation>

                                    </div>

                                </div>

                            </ng-container>

                        </div>

                    </div>

                </div>

            </ng-container>

        </div>

        <!-- Loading -->
        <app-loading-animation
            *ngIf="gettingData"
            [height]="'10rem'">
        </app-loading-animation>

        <!-- Sin registros -->
        <div
            class="empty-data"
            *ngIf="!gettingData && filteredCompaniesPass.length === 0">

            <i class="fa fa-lock"></i>

            <h4>No se encontraron contraseñas guardadas</h4>

            <p class="text-muted">
                No existen registros visibles que coincidan con tu búsqueda.
            </p>

        </div>

        <!-- Paginación -->
        <app-simple-pagination
            *ngIf="!gettingData && pagination.total > 0"
            [elements]="pagination"
            [sizes]="sizes"
            (changed)="getPaginationCompaniesPass()">
        </app-simple-pagination>

    </div>

</div>

<app-modal-pass-business
    *ngIf="modalCreate"
    [edit]="edit"
    [editCompanyName]="editCompanyName"
    (close)="closeModal($event)">
</app-modal-pass-business>